export default class VideoControls {
  constructor($el) {
    this.$el = $el;
    this.$buttonText = this.$el.querySelector('.stage-detail__video-control-text');

    const togglePlayClickBinded = this.togglePlay.bind(this);
    this.$el.addEventListener('click', togglePlayClickBinded);
  }

  togglePlay() {
    const $video = this.$el.parentNode.querySelector('.stage-detail__video .video__player');

    if ($video.paused) {
      $video.play();
      this.$el.classList.remove('stage-detail__video-control--active');
      this.$buttonText.innerHTML = 'Video pausieren';
    } else {
      $video.pause();
      this.$el.classList.add('stage-detail__video-control--active');
      this.$buttonText.innerHTML = 'Video abspielen';
    }
  }
}

document.querySelectorAll('.stage-detail__video-control').forEach(($el) => {
  // eslint-disable-next-line no-unused-vars
  const videoControl = new VideoControls($el);
});
